import { notification } from "../Components/notification";
import * as types from "./actionTypes";

const callApi = (saleId, command, method, payload) => (dispatch, getState) => {
  const state = getState();
  const apiUri = state.config.apiUri;
  const uri = `${apiUri}/sales/${saleId}/${command}`;
  var headers = new Headers();

  var user = state.oidc.user;

  if (user && user.access_token) {
    headers.append("Authorization", "Bearer " + user.access_token);
  }

  headers.set("Content-Type", "application/json; charset=utf-8");

  var promise = fetch(uri, {
    method: method,
    body: payload ? JSON.stringify(payload) : null,
    headers: headers,
  }).then((response) => {
    if (response.url.includes("discount")) {
      if (response.status === 406) {
        dispatch({
          type: types.ERROR,
          payload: "DiscountCodeNotValid",
        });
        notification("error", state.language.Discount_Invalid);
      } else {
        dispatch({ type: types.CLEAR_ERROR });
      }
    }

    if (response.url.includes("increasequantity") && response.status === 406) {
      notification("error", state.language.Could_Not_Reserve);
    }

    return Promise.resolve(response);
  });

  dispatch({
    type: types.CALL_API,
    promise,
  });
};

export const addArticle = (saleId, model) => {
  return callApi(saleId, "articles", "POST", model);
};

export const setQuantity = (saleId, key, quantity) => {
  return callApi(saleId, `articles/${key}/quantity/${quantity}`, "PUT");
};

export const removeArticle = (saleId, key) => {
  return callApi(saleId, "articles/" + key, "DELETE");
};

export const addDiscount = (saleId, id, info) => {
  return callApi(saleId, "discount", "POST", {
    id,
    info,
  });
};

export const removeDiscount = (saleId) => {
  return callApi(saleId, "discount", "DELETE");
};

export const increaseQuantity = (saleId, key) => {
  return callApi(saleId, `articles/${key}/increasequantity`, "POST");
};

export const decreaseQuantity = (saleId, key) => {
  return callApi(saleId, `articles/${key}/decreasequantity`, "POST");
};

export const setDeliveryMethod = (saleId, method) => {
  return callApi(saleId, `deliverymethod?method=${method}`, "POST");
};
